'use client';

import { Box, Container, Paper, Typography } from '@mui/material';
import { Phone } from 'lucide-react';
import { themeConfig } from 'src/theme';

export default function Page() {
  const BulletNumber = (props: { value: number }) => (
    <Box
      className="flex justify-center items-center w-[50px] h-[50px]"
      sx={{
        background: themeConfig.gradient.primary.bold,
        borderRadius: '50%',
      }}
    >
      <Typography variant="h4" color="white">
        {props.value}
      </Typography>
    </Box>
  );

  return (
    <div>
      <Box
        sx={{
          height: {
            xs: '50vh',
            md: '70vh',
          },
          backgroundImage: {
            xs: 'url(/assets/images/image-panduan-bg-mobile.webp)',
            md: 'url(/assets/images/image-panduan-bg.webp)',
          },
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'end',
        }}
      >
        <Box
          sx={{
            height: { xs: '70px', md: '100px', lg: '140px' },
            width: '100%',
            background: 'url("/assets/background/background-footer-top.svg")',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'bottom',
          }}
        />
      </Box>
      <div className="py-[100px]">
        <Container>
          <div className="mb-[78px]">
            <Typography variant="h3" textAlign="center">
              Pemesanan Tiket Bus AKAP
            </Typography>
          </div>
          <div className="flex flex-col gap-[30px] md:gap-[50px] mb-[50px] md:mb-[100px]">
            {/* =============================== */}
            {/* Pemesanan Tiket Melalui Website */}
            {/* =============================== */}
            <Paper
              elevation={8}
              sx={{
                padding: {
                  xs: '20px',
                  md: '50px',
                },
                borderRadius: {
                  xs: '10px',
                  md: '20px',
                },
              }}
            >
              <div className="px-[16px] py-[11px] md:px-[28px] md:py-[20px] bg-[#fefe01]/5 rounded-[10px] border border-[#10ba17] mb-[50px]">
                <Typography variant="h4">Pemesanan Tiket Melalui Website</Typography>
              </div>
              <div className="flex flex-col gap-[38px]">
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={1} />
                  </div>
                  <div>
                    <Typography variant="h4">Buka Website</Typography>
                    <Typography variant="h6" component="span">
                      Buka Website resmi pemesanan tiket Puspa Jaya di www.puspajaya.co.id
                    </Typography>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={2} />
                  </div>
                  <div>
                    <Typography variant="h4">Cari Tiket</Typography>

                    <ol className="list-decimal list-outside pl-[20px] text-[18px] font-bold">
                      {[
                        'Isi asal dan tujuan ',
                        'Pilih tanggal keberangkatan',
                        'Pilih jumlah kursi',
                        'Kemudian cari tiket',
                      ].map((e) => (
                        <li key={e}>
                          <Typography variant="h6" component="span">
                            {e}
                          </Typography>
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={3} />
                  </div>
                  <div>
                    <Typography variant="h4">Pilih Tiket</Typography>

                    <ol className="list-decimal list-outside pl-[20px] text-[18px] font-bold">
                      {[
                        'Pastikan titik keberangkatan dan titik tujuan sudah sesuai',
                        'Pilih seat yang anda inginkan',
                      ].map((e) => (
                        <li key={e}>
                          <Typography variant="h6" component="span">
                            {e}
                          </Typography>
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={4} />
                  </div>
                  <div>
                    <Typography variant="h4">Isi Data</Typography>

                    <ol className="list-decimal list-outside pl-[20px] text-[18px] font-bold">
                      {[
                        'Mengisi nama dan jenis kelamin sesuai dengan kartu identitas (KTP,SIM,KK)',
                        'Mengisi nomor hp yang aktif',
                        'Mengisi alamat email yang aktif untuk pengiriman e-ticket',
                      ].map((e) => (
                        <li key={e}>
                          <Typography variant="h6" component="span">
                            {e}
                          </Typography>
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <div>
                      <BulletNumber value={5} />
                    </div>
                  </div>
                  <div>
                    <Typography variant="h4">Cek Status Pemesanan</Typography>
                    <Typography variant="h6" component="span">
                      Sebelum melanjutkan ke pembayaran pastikan data pemesan telah sesuai dengan
                      jadwal keberangkatan, data penumpang dan rincian harga tiket yang diinginkan
                    </Typography>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <div>
                      <BulletNumber value={6} />
                    </div>
                  </div>
                  <div>
                    <Typography variant="h4">Metode Pembayaran</Typography>
                    <Typography variant="h6" component="span">
                      Memilih metode pembayaran sesuai yang diinginkan
                    </Typography>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <div>
                      <BulletNumber value={7} />
                    </div>
                  </div>
                  <div>
                    <Typography variant="h4">Tiket dikirim ke Email</Typography>
                    <Typography variant="h6" component="span">
                      Setelah pembayaran terkonfirmasi, e-ticket akan dikirimkan ke alamat email.
                    </Typography>
                  </div>
                </div>
              </div>
            </Paper>

            {/* =============================== */}
            {/* Pemesanan Tiket Melalui Whatsapp */}
            {/* =============================== */}
            <Paper
              elevation={8}
              sx={{
                padding: {
                  xs: '20px',
                  md: '50px',
                },
                borderRadius: {
                  xs: '10px',
                  md: '20px',
                },
              }}
            >
              <div className="px-[16px] py-[11px] md:px-[28px] md:py-[20px] bg-[#fefe01]/5 rounded-[10px] border border-[#10ba17] mb-[50px]">
                <Typography variant="h4">Pemesanan Tiket Melalui Whatsapp</Typography>
              </div>
              <div className="flex flex-col gap-[38px]">
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={1} />
                  </div>
                  <div>
                    <Typography variant="h4">
                      Penumpang dapat melihat daftar agen dibagian “Agen Perwakilan”.
                    </Typography>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={2} />
                  </div>
                  <div>
                    <Typography variant="h4">
                      Cari kontak agen yang ingin anda pilih sebagai titik keberangkatan.
                    </Typography>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={3} />
                  </div>
                  <div>
                    <Typography variant="h4">
                      Hubungi agen perwakilan tersebut sesuai dengan jam operasional yang sudah
                      tertera.
                    </Typography>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={4} />
                  </div>
                  <div>
                    <Typography variant="h4">
                      Isi data reservasi yang telah disediakan oleh agen perwakilan tersebut.
                    </Typography>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={5} />
                  </div>
                  <div>
                    <Typography variant="h4">Pilih metode pembayaran.</Typography>
                  </div>
                </div>
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={6} />
                  </div>
                  <div>
                    <Typography variant="h4">
                      Setelah pembayaran terkonfirmasi, agen akan mengirimkan e-ticket atau foto
                      berupa tiket fisik.
                    </Typography>
                  </div>
                </div>
              </div>
            </Paper>

            {/* =============================== */}
            {/* Pemesanan Tiket Melalui Agent */}
            {/* =============================== */}
            <Paper
              elevation={8}
              sx={{
                padding: {
                  xs: '20px',
                  md: '50px',
                },
                borderRadius: {
                  xs: '10px',
                  md: '20px',
                },
              }}
            >
              <div className="px-[16px] py-[11px] md:px-[28px] md:py-[20px] bg-[#fefe01]/5 rounded-[10px] border border-[#10ba17] mb-[50px]">
                <Typography variant="h4">Pemesanan Tiket Langsung ke Agen Perwakilan</Typography>
              </div>
              <div className="flex flex-col gap-[38px]">
                <div className="flex gap-[20px] items-start">
                  <div>
                    <BulletNumber value={1} />
                  </div>
                  <div>
                    <Typography variant="h4">Datang langsung ke Agen Perwakilan</Typography>
                    <Typography variant="h6" component="span">
                      Pembelian tiket bus juga dapat dilakukan secara offline dengan datang ke
                      lokasi agen perwakilan terdekat.
                    </Typography>
                  </div>
                </div>
              </div>
            </Paper>
          </div>

          <div className="flex flex-col items-center gap-[40px] md:gap-[80px]">
            <Typography variant="h4">Reservasi Bus Pariwisata</Typography>
            <Box
              sx={{
                background: themeConfig.gradient.primary.bold,
                borderRadius: {
                  xs: '10px',
                  md: '20px',
                },
                p: '50px',
                maxWidth: '800px',
              }}
            >
              <div className="flex items-start gap-[20px]">
                <Phone color="#ffffff" size={40} />
                <div>
                  <Typography variant="h6" component="span" color="white">
                    Hubungi nomor Whatsapp berikut untuk informasi reservasi bus pariwisata!
                  </Typography>
                  <Typography variant="h4" color="white">
                    0816-145-2000 (Jam Operasional 08.00-19.00 WIB)
                  </Typography>
                </div>
              </div>
            </Box>
          </div>
        </Container>
      </div>
    </div>
  );
}
